import * as flows from './../flows/async';
import React from 'react';
import LazyUniversalComponent from 'Components/LazyUniversalComponent/LazyUniversalComponent';
import { onEnterHome } from './legacyRouterHooks';

const getIndexRoute = ({ config, asyncComponentLoader }) => {
    return {
        index: true,
        component: flows.importHome(config),
        element: <LazyUniversalComponent
            component={ flows.importHome(config) }
            onEnter={ onEnterHome }
            asyncComponentLoader={ asyncComponentLoader }
        />,
        unsafeOnEnter: onEnterHome
    };
};

export default getIndexRoute;
